import React, { useState } from 'react';
import './index.scss';
import { functions, functionCodes } from './data';
import ClipMask from './components/ClipMask';
import Knob from './components/Knob';
import type { FunctionItem } from '@/types';

const Effects: React.FC = () => {
  const [activeFunction, setActiveFunction] = useState<FunctionItem>(functions[0]);

  const copyCode = (code: string) => {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        alert('代码已复制到剪贴板！');
      })
      .catch((err) => {
        console.error('复制失败:', err);
        alert('复制失败，请手动复制代码');
      });
  };

  const renderPreview = () => {
    if (!activeFunction) {
      return (
        <div className="preview-block">
          <div className="preview-header">
            <span className="preview-title">预览区域</span>
          </div>
          <div className="preview-content">
            <div className="placeholder-content">
              <h3>选择左侧功能查看预览</h3>
              <p>点击左侧列表中的功能项，可以查看对应的交互式演示效果</p>
            </div>
          </div>
        </div>
      );
    }

    switch (activeFunction.preview) {
      case 'clip-mask':
        return (
          <div className="preview-block">
            <div className="preview-header">
              <span className="preview-title">{activeFunction.name} - 预览</span>
            </div>
            <div className="preview-content">
              <ClipMask />
            </div>
          </div>
        );
      case 'knob':
        return (
          <div className="preview-block">
            <div className="preview-header">
              <span className="preview-title">{activeFunction.name} - 预览</span>
            </div>
            <div className="preview-content">
              <Knob />
            </div>
          </div>
        );
      default:
        return (
          <div className="preview-block">
            <div className="preview-header">
              <span className="preview-title">预览区域</span>
            </div>
            <div className="preview-content">
              <div className="placeholder-content">
                <h3>预览功能开发中</h3>
                <p>该功能的交互式演示正在开发中</p>
              </div>
            </div>
          </div>
        );
    }
  };

  const renderCode = () => {
    if (!activeFunction) {
      return (
        <div className="code-placeholder">
          <div className="placeholder-content">
            <h3>选择左侧功能查看代码</h3>
            <p>点击左侧列表中的功能项，可以查看对应的源代码实现</p>
          </div>
        </div>
      );
    }

    const code = functionCodes[activeFunction.id];

    return (
      <div className="code-block">
        <div className="code-header">
          <span className="code-title">{activeFunction.name} - 源代码</span>
          <button
            className="copy-btn"
            onClick={() => copyCode(code)}
            title="复制代码"
          >
            📋 复制
          </button>
        </div>
        <pre>
          <code>{code}</code>
        </pre>
      </div>
    );
  };

  return (
    <div className="effects-container">
      <div className="effects-content">
        <div className="tab-list">
          <div className="tab-items">
            {functions.map((func) => (
              <div
                key={func.id}
                className={`tab-item ${activeFunction?.id === func.id ? 'active' : ''}`}
                onClick={() => setActiveFunction(func)}
              >
                <div className="tab-icon">
                  {func.preview === 'clip-mask' && '📸'}
                  {func.preview === 'knob' && '🎛️'}
                </div>
                <div className="tab-info">
                  <h4>{func.name}</h4>
                  <p>{func.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="content-area">
          <div className="code-section">{renderCode()}</div>
          <div className="preview-section">{renderPreview()}</div>
        </div>
      </div>
    </div>
  );
};

export default Effects;
